import { List, Map, OrderedMap, Record } from 'immutable';

import type {
  MatchEntity as MatchEntityState,
  MatchesState,
  PeriodEntity as PeriodEntityState,
  TimerEntity as TimerEntityState,
} from './types';

import { MatchClass, MatchType } from './constants';

// ---

export const initialState = Record<MatchesState>(
  {
    byId: Map(),
    allIds: List(),
  },
  'MatchesState',
);

export const MatchEntity = Record<MatchEntityState>(
  {
    id: 0,
    sportId: 0,
    tournamentUnionId: 0,
    tournamentId: 0,
    tournamentStageId: 0,
    name: '',
    matchComment: '',
    matchClasses: MatchClass.ORDINARY,
    isOpen: true,
    type: MatchType.OUTRIGHT,
    betsCount: 0,
    modelType: undefined,
    slotType: undefined,
    startDate: undefined,
    liveTracker: false,
    timer: undefined,
    globalPriority: '',
    state: Map(),
    status: undefined,
    attributes: Map(),
    scores: OrderedMap(),
    periods: Map(),
    objects: Map(),
    lines: Map(),
    stakes: Map(),
    bets: Map(),
  },
  'MatchEntity',
);

export const TimerEntity = Record<TimerEntityState>(
  {
    reverse: false,
    started: false,
    gameTime: -1,
    timestamp: undefined,
  },
  'TimerEntity',
);

export const PeriodEntity = Record<PeriodEntityState>(
  {
    number: 0,
    finished: false,
  },
  'PeriodEntity',
);
